'use strict';

/**
 * material-ui-flags
 * https://github.com/ekiziltas/material-ui-flags.git
 *
 * Copyright (c) 2019 Eray KIZILTAS
 * Licensed under the MIT license.
 */

 export IconFlagAU from './Icon_Flag_AU';
 export IconFlagBG from './Icon_Flag_BG';
 export IconFlagBR from './Icon_Flag_BR';
 export IconFlagCA from './Icon_Flag_CA';
 export IconFlagCN from './Icon_Flag_CN';
 export IconFlagDE from './Icon_Flag_DE';
 export IconFlagFR from './Icon_Flag_FR';
 export IconFlagIN from './Icon_Flag_IN';
 export IconFlagRU from './Icon_Flag_RU';
 export IconFlagUS from './Icon_Flag_US';
 export IconFlagTR from './Icon_Flag_TR';
